module.exports = __webpack_public_path__ + "static/media/NocoLogo.c2f05016.png";